import { I_QREditorFormTemplate } from "@/data/types/pages";
import { PAGES } from "@/internals/constants/pages";

const structure: I_QREditorFormTemplate = {
  page: PAGES.QR_VCARD,
  metaTitle: "_metaTitle",
  metaDescription: "_metaDescription",
  title: "_vcardTitle",
  formFields: [
    {
      component: "Accordion",
      title: "_vcardNameTitle",
      className: "qrForm",
      formFields: [
        {
          component: "Input",
          type: "text",
          placeholder: "_vcardQRNamePlaceholder",
          errorMessage: [{ rule: "maxLength", message: "_vcardQRNameMaximumLength" }],
          name: "qrName",
          data_qa: "qr-vcard-name-input",
        },
      ],
    },
    {
      component: "Accordion",
      title: "_vcardThemePickerTitle",
      formFields: [
        {
          component: "ThemePicker",
          labelPrimary: "_vcardThemePickerLabelPrimary",
          labelSecondary: "_vcardThemePickerLabelSecondary",
          id: "qrVcardThemePicker",
          name: "themeColor",
          data_qa: "qr-vcard-theme-picker",
        },
      ],
    },
    {
      component: "Accordion",
      title: "_vcardInformationTitle",
      id: "qrVcardInformation",
      className: "qrvcardInformation",
      formFields: [
        {
          component: "div",
          className: "u-flex-full",
          formFields: [
            {
              component: "ImageUpload",
              title: "_vcardImageTitle",
              id: "qrVcardImage",
              showEditor: "profile",
              name: "logoUrl",
              data_qa: "qr-vcard-image-upload",
            },
          ],
        },

        {
          component: "div",
          className: "fullName-wrapper",
          formFields: [
            {
              component: "Input",
              type: "text",
              label: "_vcardFullName",
              placeholder: "_vcardFullNamePlaceholder",
              errorMessage: [{ rule: "required", message: "_requiredMessage" }],
              name: "fullName",
              data_qa: "qr-vcard-fullName-input",
            },
            {
              component: "Input",
              type: "text",
              label: "_vcardEmail",
              placeholder: "_vcardEmailPlaceholder",
              errorMessage: [{ rule: "pattern", message: "_vcardInvalidEmail" }],
              name: "email",
              data_qa: "qr-vcard-email-input",
            },
          ],
        },

        {
          component: "div",
          className: "contact-phone",
          formFields: [
            {
              component: "Input",
              type: "text",
              label: "_vcardMobilePhone",
              placeholder: "_vcardMobilePhonePlaceholder",
              name: "mobilePhone",
              data_qa: "qr-vcard-mobile-phone-input",
            },
            {
              component: "Input",
              type: "text",
              label: "_vcardLandlinePhone",
              placeholder: "_vcardLandlinePhonePlaceholder",
              name: "landlinePhone",
              data_qa: "qr-vcard-landline-phone-input",
            },

            {
              component: "Input",
              type: "text",
              label: "_vcardFaxPhone",
              placeholder: "_vcardFaxPhonePlaceholder",
              name: "fax",
              data_qa: "qr-vcard-fax-input",
            },
          ],
        },

        {
          component: "div",
          className: "job-info",
          formFields: [
            {
              component: "Input",
              type: "text",
              label: "_vcardWebsite",
              placeholder: "_vcardWebsitePlaceholder",
              name: "website",
              errorMessage: [{ rule: "pattern", message: "_vcardInvalidLink" }],
              data_qa: "qr-vcard-website-input",
            },
            {
              component: "Input",
              type: "text",
              label: "_vcardCompany",
              placeholder: "_vcardCompanyPlaceholder",
              name: "companyName",
              data_qa: "qr-vcard-company-name-input",
            },

            {
              component: "Input",
              type: "text",
              label: "_vcardProfession",
              placeholder: "_vcardProfessionPlaceholder",
              name: "profession",
              data_qa: "qr-vcard-profession-input",
            },
          ],
        },

        {
          component: "Input",
          customTag: "textarea",
          type: "text",
          label: "_vcardSummary",
          placeholder: "_vcardSummaryPlaceholder",
          errorMessage: [
            {
              rule: "maxLength",
              message: "_vcardSummaryMaximumLength",
            },
          ],
          name: "summary",
          data_qa: "qr-vcard-sumary-input",
        },
      ],
    },
    {
      component: "Accordion",
      title: "_vcardLocationTitle",
      className: "location",
      formFields: [
        {
          component: "div",
          className: "address-numeration-wrapper",
          formFields: [
            {
              component: "Input",
              type: "text",
              className: "address",
              label: "_vcardAddressLabel",
              placeholder: "_vcardAddressPlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_vcardAddressMaximumLength",
                },
              ],
              name: "address",
              data_qa: "qr-vcard-address-input",
            },
            {
              component: "div",
              className: "numeration-wrapper",
              formFields: [
                {
                  component: "Input",
                  type: "text",
                  label: "_vcardNumerationLabel",
                  placeholder: "_vcardNumerationPlaceholder",
                  errorMessage: [
                    {
                      rule: "maxLength",
                      message: "_vcardNumerationMaximumLength",
                    },
                  ],
                  name: "numeration",
                  data_qa: "qr-vcard-numeration-input",
                },
                {
                  component: "Input",
                  type: "text",
                  label: "_vcardZipCodeLabel",
                  placeholder: "_vcardZipCodePlaceholder",
                  errorMessage: [
                    {
                      rule: "maxLength",
                      message: "_vcardZipCodeMaximumLength",
                    },
                  ],
                  name: "zipCode",
                  data_qa: "qr-vcard-zip-code-input",
                },
              ],
            },
          ],
        },
        {
          component: "div",
          className: "address-state",
          formFields: [
            {
              component: "Input",
              type: "text",
              label: "_vcardCityLabel",
              className: "city",
              placeholder: "_vcardCityPlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_vcardCityMaximumLength",
                },
              ],
              name: "city",
              data_qa: "qr-vcard-city-input",
            },
            {
              component: "Input",
              type: "text",
              label: "_vcardStateLabel",
              className: "state",
              placeholder: "_vcardStatePlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_vcardStateMaximumLength",
                },
              ],
              name: "state",
              data_qa: "qr-vcard-state-input",
            },
            {
              component: "Input",
              type: "text",
              label: "_vcardCountryLabel",
              className: "country",
              placeholder: "_vcardCountryPlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_vcardCountryMaximumLength",
                },
              ],
              name: "country",
              data_qa: "qr-vcard-country-input",
            },
          ],
        },
      ],
    },

    {
      component: "Accordion",
      title: "_vcardSocialsTitle",
      formFields: [
        {
          component: "ListPicker",
          id: "qrVcardSocials",
          title: "_vcardSocialsTitleMultiple",
          titleEmpty: "_vcardSocialsTitleEmpty",
          name: "socialNetworks",
          data_qa: "qr-vcard-socials-list-picker",
          options: [
            {
              id: "facebook",
              name: "Facebook",
              value: "",
              data_qa: "facebook-button",
              placeholder: "https://facebook.com/profile",
              tooltip: { text: "Facebook", position: "top" },
            },
            {
              id: "instagram",
              name: "Instagram",
              value: "",
              data_qa: "instagram-button",
              placeholder: "https://instagram.com/profile",
              tooltip: { text: "Instagram", position: "top" },
            },
            {
              id: "twitter",
              name: "Twitter",
              value: "",
              data_qa: "twitter-button",
              placeholder: "https://twitter.com/profile",
              tooltip: { text: "Twitter", position: "top" },
            },
            {
              id: "dribbble",
              name: "Dribbble",
              value: "",
              data_qa: "dribbble-button",
              placeholder: "https://dribbble.com/profile",
              tooltip: { text: "Dribbble", position: "top" },
            },
            {
              id: "flickr",
              name: "Flickr",
              value: "",
              data_qa: "flickr-button",
              placeholder: "https://flickr.com/profile",
              tooltip: { text: "Flickr", position: "top" },
            },
            {
              id: "github",
              name: "Github",
              value: "",
              data_qa: "github-button",
              placeholder: "https://github.com/profile",
              tooltip: { text: "Github", position: "top" },
            },
            {
              id: "line",
              name: "Line",
              value: "",
              data_qa: "line-button",
              placeholder: "https://line.me/profile",
              tooltip: { text: "Line", position: "top" },
            },
            {
              id: "linkedin",
              name: "Linkedin",
              value: "",
              data_qa: "linkedin-button",
              placeholder: "https://linkedin.com/profile",
              tooltip: { text: "Linkedin", position: "top" },
            },
            {
              id: "reddit",
              name: "Reddit",
              value: "",
              data_qa: "reddit-button",
              placeholder: "https://reddit.com/profile",
              tooltip: { text: "Reddit", position: "top" },
            },
            {
              id: "skype",
              name: "Skype",
              value: "",
              data_qa: "skype-button",
              placeholder: "https://skype.com/profile",
              tooltip: { text: "Skype", position: "top" },
            },
            {
              id: "snapchat",
              name: "Snapchat",
              value: "",
              data_qa: "snapchat-button",
              placeholder: "https://snapchat.com/profile",
              tooltip: { text: "Snapchat", position: "top" },
            },
            {
              id: "tiktok",
              name: "Tiktok",
              value: "",
              data_qa: "tiktok-button",
              placeholder: "https://tiktok.com/profile",
              tooltip: { text: "Tiktok", position: "top" },
            },
            {
              id: "tripadvisor",
              name: "Tripadvisor",
              value: "",
              data_qa: "tripadvisor-button",
              placeholder: "https://tripadvisor.com/profile",
              tooltip: { text: "Tripadvisor", position: "top" },
            },
            {
              id: "tumblr",
              name: "Tumblr",
              value: "",
              data_qa: "tumblr-button",
              placeholder: "https://tumblr.com/profile",
              tooltip: { text: "Tumblr", position: "top" },
            },
            {
              id: "vimeo",
              name: "Vimeo",
              value: "",
              data_qa: "vimeo-button",
              placeholder: "https://vimeo.com/profile",
              tooltip: { text: "Vimeo", position: "top" },
            },
            {
              id: "vkontakte",
              name: "Vkontakte",
              value: "",
              data_qa: "vkontakte-button",
              placeholder: "https://vk.com/profile",
              tooltip: { text: "Vkontakte", position: "top" },
            },
            {
              id: "web",
              name: "Web",
              value: "",
              data_qa: "web-button",
              placeholder: "https://web.com/profile",
              tooltip: { text: "Web", position: "top" },
            },
            {
              id: "xing",
              name: "Xing",
              value: "",
              data_qa: "xing-button",
              placeholder: "https://xing.com/profile",
              tooltip: { text: "Xing", position: "top" },
            },
          ],
        },
      ],
    },
  ],
  layoutTranslations: {
    vcardPreviewEmail: "_vcardPreviewEmail",
    vcardPreviewPhone: "_vcardPreviewPhone",
    vcardPreviewPhoneAlt: "_vcardPreviewPhoneAlt",
    vcardPreviewFaxPhone: "_vcardPreviewFaxPhone",
    vcardPreviewWebsite: "_vcardPreviewWebsite",
    vcardPreviewCompany: "_vcardPreviewCompany",
    vcardPreviewProfession: "_vcardPreviewProfession",
    vcardPreviewAddButton: "_vcardPreviewAddButton",
  },
};

export default structure;
